import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { Bandeira } from 'src/app/shared/models/bandeira.enum';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  
  isCasasBahia = this.autenticacaoService.bandeira === Bandeira.CASAS_BAHIA;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  @Output()
  handleGoBackButton: EventEmitter<void> = new EventEmitter();

  constructor(
    public breakpointObserver: BreakpointObserver,
    private autenticacaoService: AutenticacaoService
  ) { }

  ngOnInit(): void {
  }

  handleGoBack() {
    this.handleGoBackButton.emit();
  }

}
